<template>
  <div>
    <v-layout align-center justify-center fill-height>
      <v-flex fill-height class="header" style="width:100%;">
        <table class="tablestriped" style="width:100%;">
          <thead>
            <tr>
              <th v-if="colCheckbox">
                <v-checkbox
                  color="#fec90a"
                  class="checkbox-product-line"
                  hide-details
                  v-model="maincheckbox"
                  @change="checkAllProducts()"
                ></v-checkbox>
              </th>
              <th></th>
              <th>Famille</th>
              <th>Références</th>
              <th>Marque</th>
              <!-- <th>MMD/REF</th> -->
              <th>Désignation</th>
              <th>PCB</th>
              <th>Status</th>
              <th>Promo</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(product, index) in products"
              :key="index"
              class="withpointer"
              @click="openProduct(product.pr_id)"
            >
              <td v-if="colCheckbox" :style="'width:10%; text-align:center'">
                <v-checkbox
                  color="#fec90a"
                  class="checkbox-product-line"
                  hide-details
                  v-model="product.checked"
                  @change="addproduct(product.pr_id, product.checked)"
                ></v-checkbox>
              </td>
              <td style="background-color:white;">
                <v-img
                  :src="
                    `${$config.server_url}/api/1.0/products/image/${product.pr_ref}/1/75/50?d=${now}`
                  "
                  contain
                  height="50px"
                  width="75px"
                ></v-img>
              </td>
              <td>{{ product.pr_path.split("/").join("\n") }}</td>
              <td>{{ product.pr_ref }}</td>
              <td>{{ product.pr_marque }}</td>
              <!-- <td></td> -->
              <td>{{ product.pr_name_fr }}</td>
              <td>{{ product.pr_pcb }} {{ product.pr_pcb_type }}</td>
              <td>{{ product.pr_status }}</td>
              <td>{{ product.pr_promo }}</td>
              <td
                v-if="product.pr_catalog !== 0"
                class="icon-show-products ml-2 withpointer"
                @click.stop="
                  deleteWinConfirmProduct(product.pr_id, product.pr_name_fr)
                "
              >
                <icon class="mr-2" name="trash"></icon>
              </td>
            </tr>
          </tbody>
        </table>
      </v-flex>
    </v-layout>
    <m-product-win-edit
      ref="productwinedit"
      @productWinEditSaved="productWinEditSaved"
    ></m-product-win-edit>
    <m-confirm-dialog
      v-model="confirmDeleteProduct"
      :text="
        `Souhaitez-vous vraiment effacer ce produit : ${productTodelete} ?`
      "
      title="Confirmation"
      @canceled="confirmDeleteProduct = false"
      @confirmed="deleteWinProduct()"
    ></m-confirm-dialog>
  </div>
</template>

<script>
export default {
  name: "catalog-search",
  components: {},
  props: {
    // pathToProductEdit: String,
    colCheckbox: Boolean
  },
  data() {
    return {
      maincheckbox: false,
      products: [],
      now: new Date().getTime(),
      ca_id: 0,
      productTodelete: "",
      prIdToDelete: 0,
      confirmDeleteProduct: false
    };
  },
  watch: {},
  computed: {},
  async mounted() {
    if (this.$route.params.ca_id && !this.colCheckbox) {
      this.ca_id = this.$route.params.ca_id;
    } else {
      this.ca_id = 0;
    }
    //await this.loadProducts(this.ca_id);
  },
  destroyed() {},
  methods: {
    checkAllProducts() {
      for (let iProd = 0; iProd < this.products.length; iProd++) {
        const prod = this.products[iProd];
        prod.checked = this.maincheckbox;
        this.$emit("addproduct", prod.pr_id, prod.checked);
      }
    },
    async loadProducts(ca_id, params) {
      this.now = new Date().getTime();
      let response = await this.$axios.get(
        this.$config.server_url + "/api/1.0/products/catalog/" + ca_id,
        { params }
      );
      this.products = response.data.data;
      this.loaded();
    },
    openProduct(pr_id) {
      if (this.colCheckbox) return;
      // this.$router.push(this.pathToProductEdit + pr_id);
      this.$refs.productwinedit.open(pr_id);
    },
    async productWinEditSaved() {
      await this.loadProducts(this.ca_id);
    },
    addproduct(pr_id, checked) {
      this.$emit("addproduct", pr_id, checked);
    },
    loaded() {
      this.$emit("loaded");
    },
    deleteWinConfirmProduct(pr_id, name) {
      this.productTodelete = name;
      this.prIdToDelete = pr_id;
      this.confirmDeleteProduct = true;
    },
    async deleteWinProduct() {
      // let response =
      await this.$axios.delete(
        this.$config.server_url + "/api/1.0/Products/" + this.prIdToDelete
      );
      this.confirmDeleteProduct = false;
      this.loadProducts(this.ca_id, { noSearchNoProduct: false });
    }
  }
};
</script>
<style lang="scss" scoped>
thead > tr > th {
  font-size: 13px;
  text-transform: uppercase;
  font-weight: 700;
}
.checkbox-product-line {
  margin: 0 0 0 30px;
  padding: 0;
}
</style>
